import angular from 'angular';
import template from './mobile-doctor-actions.html';
class OneToOneMobileDoctorActionsController {
    constructor(globalUi) {
        this.globalUi = globalUi;
    }
    toggleSideBar() {
        this.globalUi.ui.sidebarHidden = !this.globalUi.ui.sidebarHidden;
    }
}
const oneToOneMobileDoctorActions = {
    template,
    bindings: {
        stream: '<',
        isInGroupCall: '<',
        username: '<',
        disabled: '<',
        onToggleAudio: '&',
        hasCallEnd: '<',
        onCallEnd: '&',
    },
    controller: OneToOneMobileDoctorActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.participantVideoFrame.participantVideoFrameFull.actions.oneToOne.mobileDoctorActions', [])
    // participant-one-to-one-mobile-doctor-actions
    .component('participantOneToOneMobileDoctorActions', oneToOneMobileDoctorActions).name;
